// extracted by mini-css-extract-plugin
export default {"offersApplied":"kuNmiumWIQyiRy6Khpxm","fontSize":"yte6jaJo6z7aftWoKDDR"};